import axios from 'axios';
import CryptoJS from 'crypto-js';
import { secretKey, secretIv } from './utils';
import { notify } from "../utils/helper";

// let isLimitMessageShow = false
axios.interceptors.response.use(null, (error) => {
    // Only try to decrypt if error.response exists
  
      error.response.data = decyprtData(error?.response?.data);
    
  if (error && error.response) {
    if (error.response.status === 403) {
      if (error.response.config.method === 'get') {
        return (window.location.href = '/not-found');
      }
      if ( error.response?.data?.message === 'Your account has been suspended. please contact support team.') {
        notify('Access Denied', 'Your account has been suspended, please contact support team.');
 
      } else {
        notify('error', 'Access Denied');
      }
    }
    // if (error.response.status === 429 && !isLimitMessageShow) {
    //         notify('error', error.response?.data?.message)
    //         isLimitMessageShow= true
    //         setTimeout(() =>{
    //             isLimitMessageShow=false
    //         },5000)
    //     }
    if (error.response.status === 401 &&  error.response?.data?.message === 'Please authenticate') {
      localStorage.removeItem('accessToken');
      window.location.href = '/login';
      // initial call to whoami will get intercepted here and redirect, need to throw log event
      // TODO: Do something
    }
 
    if ( error.response.status === 401 &&  error.response?.data?.error?.name === 'TokenExpiredError' ) {
      localStorage.removeItem('accessToken');
      window.location.href = '/login';
      // initial call to whoami will get intercepted here and redirect, need to throw log event
      // TODO: Do something
    }
    // const { data } = error.response;
    // const errorPayload =
    //   data.error ||
    //   data.errors ||
    //   data.error_message ||
    //   data.error_type ||
    //   data.message;
 
    return Promise.reject(error.response);
  }
 
  return Promise.reject(error);
});
/**
 *
 * @param {*} path api endpoint
 * @returns data
 */

// const secretKey =
//   "V1HvGzTRmZXkEi/+HPpUtpeOhAcGLUGTMEsgx1fj1Ui7HAsp1mZLzISw1VmFVhuv";

export const decyprtData = (data = {}) => {
    try {
        if (data?.encryptedData?.length) {
          const SECRET_KEY = CryptoJS.enc.Utf8.parse(secretKey); // 32 chars
          const IV = CryptoJS.enc.Utf8.parse(secretIv); // 16 chars for AES 
          const decrypted = CryptoJS.AES.decrypt(data?.encryptedData, SECRET_KEY, {
            iv: IV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
          });
            return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
        } else {
            return data;
        }
    } catch (err) {
    }
};

export const encryptedData = (body = {}) => {
    const data = JSON.stringify(body);
// Use a 256-bit key (32 bytes)
const SECRET_KEY = CryptoJS.enc.Utf8.parse(secretKey); // 32 chars
const IV = CryptoJS.enc.Utf8.parse(secretIv); // 16 chars for AES 

    const encrypted = CryptoJS.AES.encrypt(data, SECRET_KEY, {
      iv: IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    
    var encrypt = encrypted.toString();
    return encrypt;
};

export async function apiGet(path, options = {}) {
    // axios.defaults.headers.common['CLIENT_IP'] = localStorage.getItem('myIp');
    // axios.defaults.headers.common['CLIENT_LOCATION'] =localStorage.getItem('location');
    const accessToken = localStorage.getItem("accessToken");
    let config;
    if (accessToken) {
        config = {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
                client_ip: localStorage.getItem("myIp"),
                client_location: localStorage.getItem("location"),
            },
        };
    } else {
        config = {
            headers: {
                "Content-Type": "application/json",
                client_ip: localStorage.getItem("myIp"),
                client_location: localStorage.getItem("location"),
            },
        };
    }

    const res = await axios.get(path, { ...config, ...options });
    if (options.responseType !== 'blob') {
        res.data = decyprtData(res?.data);
    }
    return res;
}

export function apiGetWithoutDecryption(path) {
    // axios.defaults.headers.common['CLIENT_IP'] = localStorage.getItem('myIp');
    // axios.defaults.headers.common['CLIENT_LOCATION'] =localStorage.getItem('location');
    const accessToken = localStorage.getItem("accessToken");
    let config;
    if (accessToken) {
        config = {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
                client_ip: localStorage.getItem("myIp"),
                client_location: localStorage.getItem("location"),
            },
        };
    } else {
        config = {
            headers: {
                "Content-Type": "application/json",
                client_ip: localStorage.getItem("myIp"),
                client_location: localStorage.getItem("location"),
            },
        };
    }

    return axios.get(path, config);
}

/**
 *
 * @param {*} path api endpoint
 * @param {*} data body object for post request
 * @returns
 */
export async function apiPost(path, data, responseType) {
    // axios.defaults.headers.common['CLIENT_IP'] = localStorage.getItem('myIp');
    // axios.defaults.headers.common['CLIENT_LOCATION'] =localStorage.getItem('location');
    const accessToken = localStorage.getItem("accessToken");
    let config;
    if (accessToken) {
        config = {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
                client_ip: localStorage.getItem("myIp"),
                client_location: localStorage.getItem("location"),
            },
        };
    } else {
        config = {
            headers: {
                "Content-Type": "application/json",
                client_ip: localStorage.getItem("myIp"),
                client_location: localStorage.getItem("location"),
            },
        };
    }

    if (responseType) {
        config = {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
                client_ip: localStorage.getItem("myIp"),
                client_location: localStorage.getItem("location"),
                type: "buffer",
            },
            responseType: "arraybuffer",
        };
    }

    if (!responseType) {
        const encrypted = { encrypted: encryptedData(data) };

        const res = await axios.post(path, encrypted, config);
        
        res.data = decyprtData(res?.data);
        return res;
    } else {
        return await axios.post(path, data, config);
    }
}

export async function apiPostWithStream(path, file,body) {
    // axios.defaults.headers.common['CLIENT_IP'] = localStorage.getItem('myIp');
    // axios.defaults.headers.common['CLIENT_LOCATION'] =localStorage.getItem('location');
    const accessToken = localStorage.getItem("accessToken");

        let config = {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/octet-stream',
                client_ip: localStorage.getItem("myIp"),
                'X-File-Name': file.name,
                client_location: localStorage.getItem("location"),
                'X-Body' : JSON.stringify(body)
            },
            maxBodyLength: Infinity,
        };

        return await axios.post(path, file, config);

}


export function apiPostWithMultiPart(path, data, responseType) {
    // axios.defaults.headers.common['CLIENT_IP'] = localStorage.getItem('myIp');
    // axios.defaults.headers.common['CLIENT_LOCATION'] =localStorage.getItem('location');
    const accessToken = localStorage.getItem("accessToken");
    let config;
    if (accessToken) {
        config = {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "multipart/form-data",
                client_ip: localStorage.getItem("myIp"),
                client_location: localStorage.getItem("location"),
            },
        };
    } else {
        config = {
            headers: {
                "Content-Type": "multipart/form-data",
                client_ip: localStorage.getItem("myIp"),
                client_location: localStorage.getItem("location"),
            },
        };
    }

    if (responseType) {
        config = {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "multipart/form-data",
                client_ip: localStorage.getItem("myIp"),
                client_location: localStorage.getItem("location"),
                type: "buffer",
            },
            responseType: "arraybuffer",
        };
    }

    return axios.post(path, data, config);
}



export function apiPatchWithMultiPart(path, data, responseType) {
    // axios.defaults.headers.common['CLIENT_IP'] = localStorage.getItem('myIp');
    // axios.defaults.headers.common['CLIENT_LOCATION'] =localStorage.getItem('location');
    const accessToken = localStorage.getItem("accessToken");
    let config;
    if (accessToken) {
        config = {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "multipart/form-data",
                client_ip: localStorage.getItem("myIp"),
                client_location: localStorage.getItem("location"),
            },
        };
    } else {
        config = {
            headers: {
                "Content-Type": "multipart/form-data",
                client_ip: localStorage.getItem("myIp"),
                client_location: localStorage.getItem("location"),
            },
        };
    }

    if (responseType) {
        config = {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "multipart/form-data",
                client_ip: localStorage.getItem("myIp"),
                client_location: localStorage.getItem("location"),
                type: "buffer",
            },
            responseType: "arraybuffer",
        };
    }

    return axios.patch(path, data, config);
}
/**
 *
 * @param {*} path api endpoint
 * @param {*} data  body object for path request
 * @param {*} headers  header
 * @returns
 */
export async function apiPatch(path, data, headers = {}) {
    // axios.defaults.headers.common['CLIENT_IP'] = localStorage.getItem('myIp');
    // axios.defaults.headers.common['CLIENT_LOCATION'] =localStorage.getItem('location');
    const accessToken = localStorage.getItem("accessToken");
    let config;
    if (accessToken) {
        config = {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
                client_ip: localStorage.getItem("myIp"),
                client_location: localStorage.getItem("location"),
                ...headers,
            },
        };
    } else {
        config = {
            headers: {
                "Content-Type": "application/json",
                client_ip: localStorage.getItem("myIp"),
                client_location: localStorage.getItem("location"),
                ...headers,
            },
        };
    }

    const encrypted = { encrypted: encryptedData(data) };

    const res = await axios.patch(path, encrypted, config);

    res.data = decyprtData(res?.data);
    return res;
}
/**
 *
 * @param {*} path api endpoint
 * @param {*} data body object for put request
 * @returns
 */

export function apiPut(path, data) {
    axios.defaults.headers.common["CLIENT_IP"] = localStorage.getItem("myIp");
    axios.defaults.headers.common["CLIENT_LOCATION"] =
        localStorage.getItem("location");
    const accessToken = localStorage.getItem("accessToken");
    let config;
    if (accessToken) {
        config = {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
                client_ip: localStorage.getItem("myIp"),
                client_location: localStorage.getItem("location"),
            },
        };
    } else {
        config = {
            headers: {
                "Content-Type": "application/json",
                client_ip: localStorage.getItem("myIp"),
                client_location: localStorage.getItem("location"),
            },
        };
    }

    return axios.put(path, data, config);
}
export async function apiPutWithStream(path, file, body) {
    // axios.defaults.headers.common["CLIENT_IP"] = localStorage.getItem("myIp");
    // axios.defaults.headers.common["CLIENT_LOCATION"] =
        // localStorage.getItem("location");
    const accessToken = localStorage.getItem("accessToken");
    let config;
        config = {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/octet-stream",
                client_ip: localStorage.getItem("myIp"),
                'X-File-Name': file.name,
                client_location: localStorage.getItem("location"),
                'X-Body' : JSON.stringify(body)
            },
            maxBodyLength: Infinity,
        };

    return await axios.put(path, file, config);
}
/**
 *
 * @param {*} path api endpoint
 * @param {*} data data for params
 * @returns
 */
export async function apiDelete(path, data) {
    // axios.defaults.headers.common['CLIENT_IP'] = localStorage.getItem('myIp');
    // axios.defaults.headers.common['CLIENT_LOCATION'] =localStorage.getItem('location');
    const accessToken = localStorage.getItem("accessToken");
    let config;

    const encrypted = { encrypted: encryptedData(data) };

    if (accessToken) {
        config = {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
                client_ip: localStorage.getItem("myIp"),
                client_location: localStorage.getItem("location"),
            },
            data: encrypted,
        };
    } else {
        config = {
            headers: {
                "Content-Type": "application/json",
                client_ip: localStorage.getItem("myIp"),
                client_location: localStorage.getItem("location"),
            },
            data: encrypted,
        };
    }

    const res = await axios.delete(path, { ...config });

    res.data = decyprtData(res?.data);
    return res;
}

export function apiGetWithCustomToken(path) {
    const accessToken = localStorage.getItem("ipToken");
    let config;
    if (accessToken) {
        config = {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
            },
        };
    } else {
        config = {
            headers: {
                "Content-Type": "application/json",
            },
        };
    }

    return axios.get(path, config);
}

export async function apiPostWithCustomToken(path, data, responseType, token) {
    // axios.defaults.headers.common['CLIENT_IP'] = localStorage.getItem('myIp');
    // axios.defaults.headers.common['CLIENT_LOCATION'] =localStorage.getItem('location');
    const accessToken = token;
    let config;
    if (accessToken) {
        config = {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
                client_ip: localStorage.getItem("myIp"),
                client_location: localStorage.getItem("location"),
            },
        };
    } else {
        config = {
            headers: {
                "Content-Type": "application/json",
                client_ip: localStorage.getItem("myIp"),
                client_location: localStorage.getItem("location"),
            },
        };
    }

    if (responseType) {
        config = {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
                client_ip: localStorage.getItem("myIp"),
                client_location: localStorage.getItem("location"),
                type: "buffer",
            },
            responseType: "arraybuffer",
        };
    }

    if (!responseType) {
        const encrypted = { encrypted: encryptedData(data) };

        const res = await axios.post(path, encrypted, config);
        res.data = decyprtData(res?.data);
        return res;
    } else {
        return await axios.post(path, data, config);
    }
}

const instance = axios.create();

export default instance;
